// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3EmiZ","alert":"SettungsInbox_alert__McRiy"};